import { Injectable } from '@angular/core';
import { map, Observable, switchMap, tap } from 'rxjs';
import { StaffApi } from '../apis/staff/staff.api';
import { UserApi } from '../apis/user/user.api';
import { ClinicStore } from '../stores/clinic.store';
import { StaffStore } from '../stores/staff.store';
import { UserStore } from '../stores/user.store';
import { UserTypeEnum } from '@oranta-mis/sdk';

@Injectable({
  providedIn: 'root',
})
export class AuthStaffService {
  constructor(
    private readonly userApi: UserApi,
    private readonly staffApi: StaffApi,
    private readonly userStore: UserStore,
    private readonly clinicStore: ClinicStore,
    private readonly staffStore: StaffStore,
  ) {}

  isAuthenticated(): boolean {
    if (!localStorage.getItem('token')) {
      return false;
    }
    return true;
  }

  canActivate(): Observable<boolean> {
    return this.userApi.getUser().pipe(
      switchMap((user) => {
        const clinicId = this.clinicStore.get()?.id;
        return this.staffApi
          .gets({
            pagination: { page: 1, perPage: 1 },
            where: { clinicId: clinicId, userId: user.id },
          })
          .pipe(
            tap((paginated) => {
              this.staffStore.set(paginated.list[0]);
            }),
            tap(() => {
              this.userStore.set({
                ...user,
                type: UserTypeEnum.staff,
              });
            }),
            map(() => !!user),
          );
      }),
    );
  }
}
